import socialApi from "../../../api/social/social";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // 获取列表
  getSocial({ state }, { callback }) {
    console.log(state);
    socialApi.getSocialApi({ callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/social/social.js